import React from 'react';
import { Button } from 'primereact/button';
import { Tag } from 'primereact/tag';
import '../../../assets/css/teacherMaster.css';
import userImage from '../../../assets/images/Logo.svg';
import { useNavigate } from 'react-router-dom';
import { apiBase } from '../../../utils/config';
import { InputSwitch } from 'primereact/inputswitch';

const TeacherCard = ({ teacher, handleDelete, toggleActiveStatus, handlePassword, AccessList }) => {
    const navigate = useNavigate();
    return (
        <div className="teacher-card p-mt-4">
            <img src={teacher?.ProfilePhotoUrl ? `${apiBase}/UserProfilePic/${teacher?.ProfilePhotoUrl}` : userImage} alt='' className="teacher-image" />
            <h4 className='p-m-0'>{teacher?.Name}</h4>
            <div className="subjects">
                {teacher?.subjects?.map(subject => (
                    <Tag key={subject} value={subject} />
                ))}
            </div>
            <div className="p-d-flex p-ai-center p-jc-center masters-switch">
                <Button icon="icon-view tailer-icon" className='e-btn' onClick={() => navigate('/viewEdit-teacher-master', { state: { userId: teacher?._id, isEdit: false } })} />
                <Button icon="pi pi-pencil" className='e-sction-btn p-ml-1' onClick={() => navigate('/viewEdit-teacher-master', { state: { userId: teacher?._id, isEdit: true } })} />
                <Button icon="pi pi-trash" className="e-sction-btn p-ml-1" onClick={(e) => handleDelete(teacher?._id)} />
                <InputSwitch
                    checked={teacher?.Status === 'Active' ? true : false}
                    onChange={(e) => {
                        toggleActiveStatus(teacher._id, e.value);
                    }}
                    className="p-ml-1 p-mt-1"
                />
                {teacher?.Phone && AccessList?.IsTeacher &&
                    <Button icon="pi pi-key" className="e-sction-btn p-my-0 p-mr-0 p-ml-2" onClick={(e) => handlePassword(teacher?._id)} />}
            </div>
        </div>
    );
}

export default TeacherCard;
